import type { Prio } from '@/components/landing-page/landing-page.types';
import { useMemo } from 'react';
import { PrioVersionNumber } from '@/components/landing-page/landing-page.types';

const defaultPrio: Prio = {
  variation: null,
  successBox: null,
  question: null,
  sidebar: null,
  footer: null,
};

const prioEntries = (() =>
  Object.entries(
    import.meta.glob<Prio>('@/components/landing-page/prios/*.tsx', {
      eager: true,
      import: 'default',
    }),
  ))();

// 2026-08-16: previously recomputed inside a useEffect keyed on clientSecretUrl. That value has
// nothing to do with which prio content to show — it was only ever used as a "something changed,
// recompute" trigger, relying on clientSecretUrl reliably getting a real update shortly after
// mount (via useLoadClientSecret's old-CRM secret lookup) to paper over any first-render timing
// issue. For pages whose leads live only in IUSTA (e.g. bussgeldcheck) that old-CRM lookup can
// never succeed, so clientSecretUrl may never change during the session, leaving `prio` stuck on
// whatever the first render computed (visible as generic/fallback content until a full reload).
// Deriving `prio` synchronously from `version` removes the race entirely.
export default function usePriorityVersion(version: PrioVersionNumber): Prio {
  return useMemo(() => {
    const prioEntry = prioEntries.find(([key]) => key.endsWith(`prio-${version}.tsx`));
    return prioEntry ? prioEntry[1] : defaultPrio;
  }, [version]);
}
